/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useEffect } from "react";

import { css } from "@emotion/react";

import { apiFetch } from "../../../../apiBindings";
import ImgShape from "../../../shared/Elements/ImgShape";
import GasStationHeader from "../../../shared/GasStationHeader";
import GasStationServices from "../../../shared/GasStationServices";
import NewIcon from "../../../shared/icons/Icon";
import JsonLd from "../../../shared/JsonLd";
import Menu from "../../../shared/Menu";
import PriceCards from "../../../shared/PriceCards";
import SEO from "../../../shared/SEO";
import CarCare from "./CarCare";
import lunchImage from "./mittagsangebote.jpg";
import useStore from "./store";

const GasStation = ({ page: { meta }, gasStation }) => {
    const {
        hints,
        openTimes,
        extensions,
        setGasStationError,
        setPrices,
        setHints,
        setOpenTimes,
        setExtensions,
        startLoading,
        stopLoading,
        isLoading,
        prices,
    } = useStore();

    useEffect(() => {
        if (!isLoading("comparison")) {
            startLoading("comparison");
            apiFetch(`/gas-stations/${gasStation.slug}`)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status && response.status === "error") {
                        setGasStationError(response.message);
                    } else {
                        setHints(response.hinweise);
                        setOpenTimes(response.openTimes);
                        setExtensions(response.erweiterungen);
                    }
                    stopLoading("comparison");
                })
                .catch(() =>
                    setGasStationError(
                        "Es ist ein Fehler beim Laden der Daten aufgetreten."
                    )
                );
        }
    }, [isLoading, startLoading, gasStation]);

    useEffect(() => {
        startLoading("prices");
        void apiFetch(
            `/gas-stations/${gasStation.s_id}/prices/${gasStation.s_preis_id}`
        )
            .then((response) => response.json())
            .then((response) => {
                setPrices(response);
            })
            .finally(() => stopLoading("prices"));
    }, [gasStation, setPrices, startLoading, stopLoading]);

    const url = `https://www.hoyer.de/${gasStation.slug}`;

    const paymentAccepted = gasStation.kartenakzeptanzen
        .map((item) => item.karten_name)
        .join(", ");

    const openingHoursSpecification = () => {
        const weekdays = ["mo", "di", "mi", "do", "fr", "sa", "so"];
        const openingHoursSpecification = [];
        gasStation.openTimes.forEach((openTime) => {
            let days = [];
            weekdays.forEach((day) => {
                if (openTime[day] === true) {
                    days.push(
                        day
                            .replace("mo", "Monday")
                            .replace("di", "Tuesday")
                            .replace("mi", "Wednesday")
                            .replace("do", "Thursday")
                            .replace("fr", "Friday")
                            .replace("sa", "Saturday")
                            .replace("so", "Sunday")
                    );
                }
            });
            if (days.length === 1) {
                days = days[0];
            }
            const opens = openTime["24h"] === true ? "00:00" : openTime.von;
            const closes = openTime["24h"] === true ? "23:59" : openTime.bis;
            const item = {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: days,
                opens,
                closes,
            };
            openingHoursSpecification.push(item);
        });
        return openingHoursSpecification;
    };

    const OpeningHoursSpecification = openingHoursSpecification();

    const address = {
        "@type": "PostalAddress",
        addressLocality: `${gasStation.standort_ort}, ${gasStation.landesname}`,
        postalCode: gasStation.standort_plz,
        streetAddress: `${gasStation.standort_strasse} ${gasStation.standort_nummer}`,
    };

    const telephone = gasStation.kommunikation[0]?.complete ?? undefined;

    const gasStationType =
        gasStation.stationsArt === 10
            ? "Restaurant"
            : ![2, 7, 8, 9].includes(gasStation.stationsArt)
            ? ["GasStation", "Restaurant"]
            : "GasStation";

    return (
        <>
            <SEO
                lang="de"
                slug={`tankstelle/${gasStation.slug}`}
                {...meta}
                templateFields={gasStation}
                image="https://www.hoyer-tankstellen.de/images/slider/HoyerCard2019.png"
            />

            <JsonLd>
                {{
                    "@context": "https://schema.org/",
                    "@id": url,
                    "@type": gasStationType,
                    name: gasStation.name,
                    currenciesAccepted: "EUR",
                    OpeningHoursSpecification,
                    paymentAccepted,
                    priceRange: "$$$",
                    address,
                    telephone,
                }}
            </JsonLd>

            <div
                css={css`
                    margin-bottom: 50px;
                `}
            >
                <GasStationHeader
                    gasStation={gasStation}
                    hints={hints || gasStation.hinweise}
                    openTimes={openTimes || gasStation.openTimes}
                    extensions={extensions || gasStation.erweiterungen}
                    telephone={telephone}
                />

                <PriceCards
                    headline={
                        prices?.preise
                            ? "Aktuelle Preise"
                            : "Angebotene Kraftstoffe"
                    }
                />

                {![2, 7, 8, 9].includes(gasStation.stationsArt) && (
                    <ImgShape
                        text="Rast machen und wohlfühlen"
                        headlineNumber={2}
                        side="left"
                        imgPositionX="left"
                        imgPositionY="center"
                        nonCmsImageSrc={lunchImage}
                        hasTextOutline={true}
                    />
                )}

                <Menu gasStationId={gasStation.s_id} />

                <CarCare gasStation={gasStation} />

                {(gasStation.services?.length ||
                    gasStation.kartenakzeptanzen?.length) && (
                    <GasStationServices
                        acceptanceItems={gasStation.kartenakzeptanzen.map(
                            (item) => ({
                                text: item.karten_name,
                                icon: <NewIcon iconImg={item.karten_icon} />,
                            })
                        )}
                        servicesItems={gasStation.services.map((item) => ({
                            text: item.service_name,
                            icon: <NewIcon iconImg={item.service_icon} />,
                        }))}
                    />
                )}
            </div>
        </>
    );
};

export default GasStation;
